import React, { useEffect, useState } from "react";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import RestService from "./../../Restservice";
import CustomTable from "./../../component/CustomTable";
import PaymentIconLink from "./../../component/PaymentIconLink";
import { Link } from "react-router-dom";
import Select from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import FAQ from "./FAQ";

const useStyles = makeStyles((theme) => ({
  setSelect: {
    width: "80%",
  },
}));
export default function PremiumServicesPage() {
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState({});
  const [groupdata, setgroupdata] = useState({});
  const [watchlistid, setwatchlistid] = useState("");
  const [portfolioid, setportfolioid] = useState("");
  const [strategyid, setstrategyid] = useState("");
  const [sectorid, setsectorid] = useState("");
  const [autosignalid, setautosignalid] = useState("");
  const [screenerid, setscreenerid] = useState("");
  const [filtertype, setfiltertype] = useState(0);
  const [buySectorid, setBuySectorid] = useState(61);
  const [showType, setShowType] = useState(0);
  const [sellSectorid, setSellSectorid] = useState(61);
  const [signal, setsignal] = useState(false);
  const [ntime, setntime] = useState(false);
  const [getBuyValue, setBuyValue] = useState({
    value: "61",
    label: "F&O Stocks",
  });
  const [getSellValue, setSellValue] = useState({
    value: "61",
    label: "F&O Stocks",
  });
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";

  const classes = useStyles();

  useEffect(() => {
    setLoading(true);
    RestService.getTradingTerminal(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data);
        setgroupdata(response.data.globalData);
        setsignal(response.data.signal);
        setsignal(response.data.signal);
        setShowType(response.data.showType);
      },
      mobile,
      web_token,
      filtertype,
      watchlistid,
      portfolioid,
      sectorid,
      strategyid,
      autosignalid,
      screenerid,
      buySectorid,
      sellSectorid
    );
  }, [
    ntime,
    mobile,
    web_token,
    filtertype,
    watchlistid,
    portfolioid,
    sectorid,
    strategyid,
    autosignalid,
    screenerid,
    buySectorid,
    sellSectorid,
  ]);
  function getBuySectorid(event) {
    setBuySectorid(event.value);
    setBuyValue(event);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  function getSellSectorid(event) {
    setSellSectorid(event.value);
    setSellValue(event);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }

  function getwatchlistId(event) {
    setwatchlistid(event.value);
    setfiltertype(1);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  function getportfolioid(event) {
    setportfolioid(event.value);
    setfiltertype(2);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  function getSectorid(event) {
    setsectorid(event.value);
    setfiltertype(3);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  function getsetstrategyid(event) {
    setstrategyid(event.value);
    setfiltertype(4);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  function getautosignalid(event) {
    setautosignalid(event.value);
    setfiltertype(5);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  function getscreenerid(event) {
    setscreenerid(event.value);
    setfiltertype(6);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }

  return (
    <>
      {loading ? <Loader /> : ""}

      <GlobalHelmet />
      <div className="bodycontainer">
        <div className="custom-auto-space">
          <div className=" ">
            <div className="news-original">
              <div className="row">
                <div className="col-md-12 ">
                  <div className="row">
                    <div className="col-12">
                      <div className="header-data">
                        <label className="header-data-span">
                          Nifty :
                          {groupdata[6] ? (
                            <span
                              className={
                                groupdata[6]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[6]["l"]} {groupdata[6]["c"]} (
                              {groupdata[6]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span">
                          Bank Nifty :
                          {groupdata[5] ? (
                            <span
                              className={
                                groupdata[5]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[5]["l"]} {groupdata[5]["c"]} (
                              {groupdata[5]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span">
                          Sensex :
                          {groupdata[0] ? (
                            <span
                              className={
                                groupdata[0]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[0]["l"]} ({groupdata[0]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span">
                          India Vix :
                          {groupdata[7] ? (
                            <span
                              className={
                                groupdata[7]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[7]["l"]} ({groupdata[7]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span header-data-span-box">
                          Nifty :
                          {showType > 0 ? (
                            <span
                              className={
                                signal.NIFTYSignal === "IntradaySell" ||
                                signal.NIFTYSignal === "JackpotSell" ||
                                signal.NIFTYSignal === "DnTrend" ||
                                signal.NIFTYSignal === "LongTSell" ||
                                signal.NIFTYSignal === "ShortTSell"
                                  ? "txtRed"
                                  : "txtGreen"
                              }
                            >
                              {signal.NIFTYSignal}
                            </span>
                          ) : (
                            <span>--</span>
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="col-12 mt-1">
                      <div className="header-data   pb-3">
                        <label className="header-data-span">
                          Gold :
                          {groupdata[1] ? (
                            <span
                              className={
                                groupdata[1]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[1]["l"]} ({groupdata[1]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span">
                          Silver :
                          {groupdata[2] ? (
                            <span
                              className={
                                groupdata[2]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[2]["l"]} ({groupdata[2]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span">
                          Crude :
                          {groupdata[3] ? (
                            <span
                              className={
                                groupdata[3]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[3]["l"]} ({groupdata[3]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span">
                          USD/INR :
                          {groupdata[4] ? (
                            <span
                              className={
                                groupdata[4]["cp"] > 0 ? "greenTxt" : "redTxt"
                              }
                            >
                              {groupdata[4]["l"]} ({groupdata[4]["cp"]}%)
                            </span>
                          ) : (
                            ""
                          )}
                        </label>
                        <label className="header-data-span header-data-span-box">
                          Bank Nifty :
                          {showType > 0 ? (
                            <span
                              className={
                                signal.bNIFTYSignal === "IntradaySell" ||
                                signal.bNIFTYSignal === "JackpotSell" ||
                                signal.bNIFTYSignal === "DnTrend" ||
                                signal.bNIFTYSignal === "LongTSell" ||
                                signal.bNIFTYSignal === "ShortTSell"
                                  ? "txtRed"
                                  : "txtGreen"
                              }
                            >
                              {signal.bNIFTYSignal}
                            </span>
                          ) : (
                            <span>--</span>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-2 col-6 ">
                      <label className="font-bold">
                        {showType > 0 ? "Latest Buy Signal" : ""}
                      </label>
                      <Select
                        value={getBuyValue ? getBuyValue : []}
                        onChange={getBuySectorid}
                        options={
                          globaldata.sectorList ? globaldata.sectorList : []
                        }
                        name="stock_id"
                        className=""
                        isDisabled={showType === 0 ? true : false}
                      />
                      {showType === 0 && <PaymentIconLink />}
                    </div>
                    <div className="col-sm-10 col-6 mt-4 pt-1  ">
                      <marquee className="marqueed">
                        {globaldata.buyData
                          ? globaldata.buyData.map((item, key) => (
                              <label className="marquee-label" key={key}>
                                <Link to={"/stocks/" + item.symbol}>
                                  {item.symbol}
                                </Link>
                                <span
                                  className={
                                    item.cp > 0 ? "greenTxt " : "redTxt"
                                  }
                                >
                                  {item.l}({item.cp}%)
                                </span>
                                {showType > 0 && (
                                  <span className="greenTxt">
                                    {item.signal}
                                  </span>
                                )}
                              </label>
                            ))
                          : ""}
                      </marquee>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-2 col-6">
                      <label className="font-bold">
                        {showType > 0 ? "Latest Sell Signal" : ""}
                      </label>
                      <Select
                        value={getSellValue ? getSellValue : []}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        menuPosition={"fixed"}
                        onChange={getSellSectorid}
                        options={
                          globaldata.sectorList ? globaldata.sectorList : []
                        }
                        name="stock_id"
                        isDisabled={showType === 0 ? true : false}
                      />
                      {showType === 0 && <PaymentIconLink />}
                    </div>
                    <div className="col-sm-10 col-6 mt-2 pt-4">
                      <marquee className="marqueed">
                        {globaldata.sellData
                          ? globaldata.sellData.map((item, key) => (
                              <label className="marquee-label" key={key}>
                                <Link to={"/stocks/" + item.symbol}>
                                  {item.symbol}
                                </Link>
                                <span
                                  className={
                                    item.cp > 0 ? "greenTxt " : "redTxt"
                                  }
                                >
                                  {item.l}({item.cp}%)
                                </span>
                                {showType > 0 && (
                                  <span className="redTxt">{item.signal} </span>
                                )}
                              </label>
                            ))
                          : ""}
                      </marquee>
                    </div>
                  </div>

                  {/* <h3><span className="highlighttext">Premium Services</span> </h3> */}
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-lg-2 col-md-3 col-6">
                <label>Select Watchlist</label>
                <Select
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPosition={"fixed"}
                  onChange={getwatchlistId}
                  options={globaldata.watchlist ? globaldata.watchlist : []}
                  name="stock_id"
                  className=""
                />
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <label>Select Portfolio</label>
                <Select
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPosition={"fixed"}
                  onChange={getportfolioid}
                  options={globaldata.portfolio ? globaldata.portfolio : []}
                  name="stock_id"
                  className=""
                />
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <label>Select Sector</label>
                <Select
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPosition={"fixed"}
                  onChange={getSectorid}
                  options={globaldata.sectorList ? globaldata.sectorList : []}
                  name="stock_id"
                  className=""
                />
              </div>
              <div className="col-lg-2 col-md-3   col-6">
                <label>Select Strategy</label>
                <Select
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPosition={"fixed"}
                  onChange={getsetstrategyid}
                  options={
                    globaldata.strategyList ? globaldata.strategyList : []
                  }
                  name="stock_id"
                  className={showType === 0 ? classes.setSelect : ""}
                  isDisabled={showType === 0 ? true : false}
                />
                {showType === 0 && <PaymentIconLink styles={"left:-10px"} />}
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <label>Select Autosignal</label>
                <Select
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPosition={"fixed"}
                  onChange={getautosignalid}
                  options={
                    globaldata.autoSignalList ? globaldata.autoSignalList : []
                  }
                  name="stock_id"
                  className=""
                  isDisabled={showType === 0 ? true : false}
                />
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <label>Select Screener</label>
                <Select
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPosition={"fixed"}
                  onChange={getscreenerid}
                  options={
                    globaldata.screenerList ? globaldata.screenerList : []
                  }
                  name="stock_id"
                  className=""
                  isDisabled={showType === 0 ? true : false}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 pt-4">
                {globaldata.getDetails &&
                globaldata.getDetails.length > 0 &&
                globaldata.setColumn.length > 0 ? (
                  <>
                    <CustomTable
                      columndata={
                        globaldata.setColumn ? globaldata.setColumn : ""
                      }
                      marketdata={
                        globaldata.getDetails ? globaldata.getDetails : ""
                      }
                      pageSizeNumber="10"
                      redirectlink="/stocks/"
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="row">
            <div className="col-md-12 ">
              <FAQ/>
            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
